<template>
  <div class="homepage-container">
    <!-- Section 1: Promo Header Section -->
    <section class="promo-header text-center">
      <div class="container">
        <h1 class="promo-title animate-fade-in" v-html="$t('Home.BannerTitle')"></h1>
        <p class="promo-desc animate-fade-in delay-1" v-html="$t('Home.BannerDesc')"></p>
      </div>
    </section>

    <!-- Section 2: Claim Your Offer Section -->
    <section class="claim-offer">
      <!-- Desktop side triangles absolute positioned at the edges -->
      <div class="triangles-side left-side d-none d-lg-flex animate-slide-left">
        <img :src="$t('Home.ClaimYourOfferDesktopImg')" alt="Decorative Pattern" />
      </div>
      
      <div class="container">
        <div class="claim-content text-center animate-fade-in delay-2">
          <!-- Mobile view decorative triangles pattern placed above the header -->
          <div class="mobile-triangles-wrapper d-block d-lg-none">
            <img :src="$t('Home.ClaimYourOfferMobileImg')" alt="Decorative Pattern" class="mobile-triangles" />
          </div>

          <h2 class="claim-heading">{{ $t('Home.ClaimYourOfferTitle') }}</h2>
          <p class="claim-text" v-if="$t('Home.ClaimYourOfferDesc')" v-html="$t('Home.ClaimYourOfferDesc')"></p>
          
          <div class="btn-container">
            <router-link to="/SignIn" class="btn btn-claim-offer">
              {{ $t('Home.GetStartedBtn') }}
            </router-link>
          </div>

          <div class="claim-nav-links">
            <div class="nav-link-item">
              {{ $t('Home.TroubleParticipating') }} <router-link to="/FAQ" class="accent-link">{{ $t('Home.FAQsText') }}</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="triangles-side right-side d-none d-lg-flex animate-slide-right">
        <img :src="$t('Home.ClaimYourOfferDesktopImg')" alt="Decorative Pattern" class="flip-horizontal" />
      </div>
    </section>

    <!-- Section 3: How It Works Section -->
    <section class="how-it-works" :style="{ '--htw-bg-desktop': 'url(' + $t('Home.HtwBgDesktop') + ')', '--htw-bg-mobile': 'url(' + $t('Home.HtwBgMobile') + ')' }">
      <div class="container htw-container">
        <h2 class="htw-heading text-center d-none d-md-block animate-fade-in">{{ $t('Home.HtwTitleDesktop') }}</h2>
        <h2 class="htw-heading text-center d-md-none animate-fade-in">{{ $t('Home.HtwTitleMobile') }}</h2>
        
        <div class="htw-cards-grid">
          <!-- Card 1 -->
          <div class="htw-card animate-card-delay-1">
            <div class="card-icon-container">
              <img :src="$t('Home.HtwStep1Img')" alt="Register Icon" />
            </div>
            <h3 class="card-title">{{ $t('Home.HtwStep1Title') }}</h3>
            <p class="card-desc">{{ $t('Home.HtwStep1Desc') }}</p>
          </div>

          <!-- Card 2 -->
          <div class="htw-card animate-card-delay-2">
            <div class="card-icon-container">
              <img :src="$t('Home.HtwStep2Img')" alt="Shop Icon" />
            </div>
            <h3 class="card-title">{{ $t('Home.HtwStep2Title') }}</h3>
            <p class="card-desc">{{ $t('Home.HtwStep2Desc') }}</p>
          </div>

          <!-- Card 3 -->
          <div class="htw-card animate-card-delay-3">
            <div class="card-icon-container">
              <img :src="$t('Home.HtwStep3Img')" alt="Get Rewarded Icon" />
            </div>
            <h3 class="card-title">{{ $t('Home.HtwStep3Title') }}</h3>
            <p class="card-desc">{{ $t('Home.HtwStep3Desc') }}</p>
          </div>
        </div>
      </div>
    </section>

    
  </div>
</template>

<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
/* Promo Header Section */
.promo-header {
  padding: 3rem 0;
  background-color: #ffffff;
}

.promo-title {
  color: #2584C5;
  font-size: 2.5rem;
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
}

:deep(.text-primary) {
  color: #2584C5 !important;
}

:deep(.text-dark) {
  color: #000000 !important;
}

.promo-desc {
  font-size: 1.15rem;
  color: #333333;
  line-height: 1.7;
  max-width: 860px;
  margin: 0 auto;
}

/* Claim Your Offer Section */
.claim-offer {
  padding: 3.5rem 0;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.triangles-side {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  max-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.left-side {
  left: 0;
}

.right-side {
  right: 0;
}

.triangles-side img {
}

.flip-horizontal {
  transform: scaleX(-1);
}

.claim-content {
  max-width: 600px;
  margin: 0 auto;
  padding: 0 1rem;
  position: relative;
  z-index: 2;
}

.mobile-triangles-wrapper {
  margin-bottom: 2rem;
  width: 100%;
}

.mobile-triangles {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
}

.claim-heading {
  font-size: 2.25rem;
  font-weight: 700;
  color: #000000;
  margin-bottom: 1rem;
}

.claim-text {
  font-size: 1.1rem;
  color: #555555;
  margin-bottom: 2rem;
}

.btn-container {
  margin-bottom: 2.25rem;
}

.btn-claim-offer {
  display: inline-block;
  background-color: #2584C5;
  color: #ffffff !important;
  font-size: 1.15rem;
  font-weight: 600;
  padding: 0.75rem 5rem;
  border-radius: 4px;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(37, 132, 197, 0.25);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.btn-claim-offer:hover {
  background-color: #1b6ca2;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(37, 132, 197, 0.4);
  text-decoration: none !important;
}

.btn-claim-offer:active {
  transform: translateY(0);
}

.claim-nav-links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.nav-link-item {
  font-size: 0.95rem;
  color: #666666;
}

.accent-link {
  color: #2584C5 !important;
  text-decoration: underline !important;
  font-weight: 500;
}

.accent-link:hover {
  color: #1b6ca2 !important;
}

/* How It Works Section */
.how-it-works {
  background-image: var(--htw-bg-desktop);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 6rem 0;
  position: relative;
}

.htw-container {
  max-width: 1200px;
  margin: 0 auto;
}

.htw-heading {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4rem;
}

.htw-cards-grid {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 2rem;
}

.htw-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 3rem 2rem;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  flex: 1;
  backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.htw-card:hover {
  transform: translateY(-8px);
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  background: rgba(255, 255, 255, 0.12);
}

.card-icon-container {
  background: #ffffff;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.card-icon-container img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.card-title {
  font-size: 1.35rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #ffffff;
}

.card-desc {
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
}

/* Animations */
.animate-fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
}

.delay-1 {
  animation-delay: 0.2s;
}

.delay-2 {
  animation-delay: 0.4s;
}

.animate-slide-left {
  opacity: 0;
  transform: translateY(-50%) translateX(-30px);
  animation: slideLeft 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.3s;
}

.animate-slide-right {
  opacity: 0;
  transform: translateY(-50%) translateX(30px);
  animation: slideRight 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.3s;
}

.animate-card-delay-1 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.4s;
}

.animate-card-delay-2 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.6s;
}

.animate-card-delay-3 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.8s;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideLeft {
  to {
    opacity: 0.85;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes slideRight {
  to {
    opacity: 0.85;
    transform: translateY(-50%) translateX(0);
  }
}

/* Responsive Design */
@media screen and (max-width: 1199px) {
  .promo-title {
    font-size: 2.25rem;
  }
  .claim-heading {
    font-size: 2rem;
  }
  .htw-heading {
    font-size: 2.25rem;
  }
  .triangles-side {
    width: 15%;
  }
}

@media screen and (max-width: 991px) {
  .htw-cards-grid {
    flex-direction: column;
    gap: 1.5rem;
    padding: 0 1rem;
  }
  
  .htw-card {
    padding: 2.5rem 2rem;
  }
  
  .how-it-works {
    padding: 4.5rem 0;
  }
  
  .htw-heading {
    margin-bottom: 3rem;
  }
}

@media screen and (max-width: 767px) {
  .promo-title {
    font-size: 1.85rem;
    margin-top: 1rem;
  }
  
  .promo-desc {
    font-size: 1rem;
    padding: 0 10px;
  }
  
  .claim-offer {
    padding: 2.5rem 0;
  }
  
  .claim-heading {
    font-size: 1.75rem;
  }
  
  .claim-text {
    font-size: 1rem;
  }
  
  .btn-claim-offer {
    padding: 0.75rem 3.5rem;
    font-size: 1.05rem;
    width: 100%;
    max-width: 280px;
  }
  
  .how-it-works {
    background-image: var(--htw-bg-mobile);
    padding: 3.5rem 0;
  }
  
  .htw-heading {
    font-size: 1.85rem;
    margin-bottom: 2.5rem;
  }
}
</style>
